module.exports = __webpack_public_path__ + "img/btn_menu_js.af899f59.png";